import { useContext } from 'react';
import { useInView } from 'react-intersection-observer';
import { useSupportsNativeLazyLoading } from '../utils/hooks/useSupportsNativeLazyLoading';
import LazyContext from './LazyContext';
export function useLazyLoading(inDumbo) {
    if (inDumbo === void 0) { inDumbo = false; }
    var enableLazyLoading = useContext(LazyContext);
    var supportsNativeLazy = useSupportsNativeLazyLoading();
    var _a = useInView({
        triggerOnce: true,
        threshold: 0,
        rootMargin: '50% 0% 50% 0%',
    }), ref = _a[0], inView = _a[1];
    return {
        enableLazyLoading: enableLazyLoading,
        supportsNativeLazy: supportsNativeLazy,
        ref: ref,
        inView: inView,
    };
}
//# sourceMappingURL=useLazyLoading.js.map